export default "__VITE_ASSET__WtkVDYTW__"